import Loadable from "react-loadable";
import LoadingComponent from "../../../../commons/loader"

export default [
	{
		path: "/clients/:customer_id/company/:company_id/overhead",
		exact: true,
		auth: true,
		component: Loadable({
			loader: () => import("./pages/index"),
			loading: LoadingComponent
		})
	}
]


// WEBPACK FOOTER //
// ./src/modules/company/pages/overhead/routes.js